<template>
    <div class="card-panel">
        <div class="card-body">
            <h4> Attached Devices </h4>
            <div class="text-center">
                <img src="@/assets/img/home/img_home_attached_devices.png" @click="isTopoShow = !isBridge" class="click-topo"></div>
            <div class="form-group text-center">
                &nbsp;
            </div>
            <div class="form-group text-center">
                <p>Link to DHCP client</p>
            </div>
            <div class="form-group text-center">
                <p v-if="!isBridge" @click="isTopoShow = !isBridge" class="click-topo">Number of devices : <span class="text-green-highlight" >{{devicesNum}}</span></p>
                <p v-else class="bridge-info">Bridge mode cannot get DHCP client info</p>
            </div>
            
        </div>
        <div class="card-footer  border-top home-btn">
            <el-button  :loading="isLoad" @click="getData" :disabled="isBridge">Refresh</el-button>
        </div>
        <!-- 下挂设备 TOPO信息 -->
        <Topo :isShow="isTopoShow" :topoData="topoD" @closeTopo="closeTopo" ></Topo>
    </div>
</template>

<script>
import Topo from './topo'
import devConfig from '@/devConfig'
// import topoTestD from '@/test/topo_data'
export default {
    components:{Topo},
    data() {
        return {
            isLoad:false,
            isTopoShow:false,
            topoD:{},
            devicesNum:0,
            isMainRoute:false,
            isBridge:false
        }
    },
    created(){
        devConfig.init(this,()=>{
            this.isBridge = devConfig.getData().isBridge
            this.getData()
        })
    },
    methods:{
        closeTopo(){
            this.getData()
            this.isTopoShow = false
        },
        getData(){
            if(!this.isBridge)
            {
                axios
                .post("/boafrm/fhFilink",{
                    CmdType:"GET_SUBDEV_INFO",
                })
                .then((response)=>{
                    // response.data = topoTestD
                    if(response.data.subDevInfo)
                    {
                        this.topoD = response.data.subDevInfo
                        let _cDevList = []
                        let _subList = []
                        this.topoD.MainBaseInfo.forEach((e)=>{
                            if(Object.keys(e).length != 0) _cDevList.push(e)
                        })
                        
                        if(this.topoD.ChildRouter)
                        {
                            this.topoD.ChildRouter.forEach((e) => {
                                if(Object.keys(e).length != 0)
                                {
                                    _subList.push(e)
                                    e.ChildBaseInfo.forEach((c)=>{
                                        if(Object.keys(c).length != 0)
                                        {
                                            let found = false
                                            for (let index = 0; index < _cDevList.length; index++) {
                                                if(_cDevList[index].Mac === c.Mac) 
                                                {
                                                    found = true
                                                    break
                                                }
                                            }
                                            if(!found) _cDevList.push(c)
                                        }
                                        
                                    })
                                }
                            })
                        }
                        
                        _cDevList = _cDevList.filter(e => {
                            for (let index = 0; index < _subList.length; index++) {
                                if(_subList[index].Mac === e.Mac) return false
                            }
                            return true
                        })
                        this.devicesNum = _cDevList.length
                    }
                })
            }            
        }
    }
}
</script>
<style scoped>
.click-topo{
    cursor: pointer;
}

</style>

